module.exports = __webpack_public_path__ + "d308073b/img/share-icon.0f8a11b4.svg";